import { Address } from "../address/address";
import { CompanyDebt } from "./company-debt";
import { CompanyUhcDetails } from "./company-uhc-details";
import { Entity } from "./entity";
import { CompanyStatus, CompanyType, CompanySubtype } from "./company-enums";
import { SecurityStructure } from './security-structure';
import { Note } from "../notes/note";
import { Relationship } from "../relationships/relationship";

export class Company extends Entity {
    static override readonly $type = 'Company';
    acn: string;
    status: CompanyStatus | undefined;
    companyType: CompanyType | undefined;
    companySubtype?: CompanySubtype | undefined;
    ultimateHoldingCompany?: CompanyUhcDetails;
    nextAnnualReviewDate: string | Date;
    officers: Relationship[] = [];
    currentOfficers: Relationship[] = [];
    currentSecurityholders: Relationship[] = [];
    companyDebt?: CompanyDebt;
    corporateKey: string;
    principalAddress: Address;
    isPublic: boolean;
    shareClasses: SecurityStructure[];
    notes: Note[] = [];
    refreshedOn: Date;
    bPayReference: string;
    postBillpay: string;

    constructor(data: Partial<Company> = {}) {
        super(data);
        this.notes = data.notes ?? [];
        this.registeredAddress = data.registeredAddress ? new Address(data.registeredAddress) : new Address();
        this.acn = data.acn ?? '';
        this.principalAddress = data.principalAddress ? new Address(data.principalAddress) : new Address();
        this.status = data.status;
        this.companyType = data.companyType;
        this.companySubtype = data.companySubtype;
        this.ultimateHoldingCompany = data.ultimateHoldingCompany ? new CompanyUhcDetails(data.ultimateHoldingCompany) : data.ultimateHoldingCompany;
        this.nextAnnualReviewDate = data.nextAnnualReviewDate ?? '';
        this.officers = data.officers?.length ? data.officers.map((officer) => new Relationship(officer)) : [];
        this.companyDebt = data.companyDebt ? new CompanyDebt(data.companyDebt) : new CompanyDebt();
        this.corporateKey = data.corporateKey ?? '';
        this.isPublic = data.isPublic ?? false;
        this.shareClasses = data.shareClasses ?? [];
        this.currentOfficers = data.currentOfficers?.length ? data.currentOfficers.map((officer) => new Relationship(officer)) : [];
        this.currentSecurityholders = data.currentSecurityholders?.length ? data.currentSecurityholders.map((officer) => new Relationship(officer)) : [];
        this.refreshedOn = data.refreshedOn ? new Date(data.refreshedOn) : new Date();
        this.bPayReference = data.bPayReference ?? '';
        this.postBillpay = data.postBillpay ?? '';
    }
}
